import { render, staticRenderFns } from "./CouponTwo.vue?vue&type=template&id=3b5b3728&scoped=true"
import script from "./CouponTwo.vue?vue&type=script&lang=js"
export * from "./CouponTwo.vue?vue&type=script&lang=js"
import style0 from "./CouponTwo.vue?vue&type=style&index=0&id=3b5b3728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b3728",
  null
  
)

export default component.exports